import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {View} from 'react-native';
import {Touchable} from 'trpc-react-native-ui';
import theme, {getUsageStyle} from '../../../theme-config';
import DoughnutWithContentAndFill from '../../common/DoughnutWithContentAndFill';

import {
  BaseDoughnutLegend,
  DurationDoughnutLegend,
  MonetaryDoughnutLegend,
  SmsDoughnutLegend,
  VolumeDoughnutLegend,
} from './DoughnutLegend';

class UsageDoughnut extends Component {
  _renderDoughnutLegend(unit) {
    const {label, current, max, isActive = false, hideMaxValue} = this.props;
    const {textColor} = getUsageStyle(label, theme);
    const props = {
      current,
      max,
      isActive,
      label,
      hideMaxValue,
      color: textColor,
    };
    switch (unit) {
      case 'DURATION':
        return <DurationDoughnutLegend {...props} />;
      case 'MONETARY':
        return <MonetaryDoughnutLegend {...props} />;
      case 'VOLUME':
        return <VolumeDoughnutLegend {...props} />;
      case 'NUMBER':
      case 'SMS':
        return <SmsDoughnutLegend {...props} />;
      default:
        return <BaseDoughnutLegend {...props} />;
    }
  }

  render() {
    const {
      size,
      label,
      current,
      max,
      isActive = false,
      unitType,
      onPress,
    } = this.props;
    const {
      borderColor,
      iconColor,
      textColor: usageColor,
    } = getUsageStyle(label, theme);
    const textColor = !max ? theme.gray.normalLight : usageColor;
    const doughnutWithContentAndFillProps = {
      isActive,
      label,
      size,
      max,
      current,
      borderColor,
      iconColor,
      textColor,
    };

    return (
      <View style={[this.props.style, {alignItems: 'center'}]}>
        <Touchable
          borderRadius={size / 2}
          onPress={typeof onPress === 'function' ? onPress : null}>
          <View>
            <DoughnutWithContentAndFill {...doughnutWithContentAndFillProps} />
          </View>
        </Touchable>

        {this._renderDoughnutLegend(unitType)}
      </View>
    );
  }
}

UsageDoughnut.propTypes = {
  isActive: PropTypes.bool,
  current: PropTypes.number,
  max: PropTypes.any,
  label: PropTypes.string,
  size: PropTypes.number,
  onPress: PropTypes.func,
  unitType: PropTypes.string,
};

module.exports = UsageDoughnut;
